<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :selection="selection" :col-span="colSpan" :get-action="queryApi" :before-query-search="beforeQuerySearch" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @afterFetchOriginalData="afterFetchOriginalData" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <!-- 分区类型 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.zoneType')" prop="partitionType">
            <BjSelectLov v-model="queryParams.partitionType" :option-list="ZONE_TYPE_LIST" :placeholder="$t('billingPage.zoneType')" @change="onQueryPartitionTypeChange" />
          </el-form-item>
        </el-col>
        <!-- 分区：全显示 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.zone')" prop="partitionValue">
            <BjInput :value="queryParams.partitionValue" :placeholder="$t('billingPage.zone')" @input="handleQueryZoneInput" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 国家：全显示 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.country')" prop="country">
            <BjSelectLov v-model="queryParams.country" :option-list="COUNTRY_NAME_AND_TWOCODE" :placeholder="$t('BusinessLogisticsCompanyPostCode.country')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 城市：仅城市类型(2)可用，其余置灰 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.zoneCity')" prop="city">
            <BjInput v-model="queryParams.city" :disabled="queryParams.partitionType !== '2'" :placeholder="$t('billingPage.zoneCity')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 邮编范围开始：邮编类型(1)或城市类型(2)可用，其余置灰 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.PostcodeS')" prop="postCodeFrom">
            <BjInput ref="queryPostCodeFrom" :value="queryParams.postCodeFrom" :disabled="queryParams.partitionType !== '1' && queryParams.partitionType !== '2'" :placeholder="$t('billingPage.PostcodeS')" @input="handlePostCodeInput('queryParams', 'postCodeFrom', $event, 'queryPostCodeFrom')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 邮编范围结束：邮编类型(1)或城市类型(2)可用，其余置灰 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.PostcodeE')" prop="postCodeTo">
            <BjInput ref="queryPostCodeTo" :value="queryParams.postCodeTo" :disabled="queryParams.partitionType !== '1' && queryParams.partitionType !== '2'" :placeholder="$t('billingPage.PostcodeE')" @input="handlePostCodeInput('queryParams', 'postCodeTo', $event, 'queryPostCodeTo')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableOperation>
        <el-col>
          <el-button v-permission:USER-ONBOARDING-ADD type="primary" class="main-btn" @click="onAdd">{{ $t('createText') }}</el-button>
          <el-button type="primary" class="main-btn" @click="onBulkDel">{{ $t('bulkDelText') }}</el-button>
          <el-button type="primary" class="main-btn" @click="onImport">{{ $t('importDataText') }}</el-button>
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'partitionType'">
                {{ ZONE_TYPE_LIST.bjGet(scope.row.partitionType) }}
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <el-dialog :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
      <el-form ref="form" :model="form" status-icon :rules="rules" label-position="top" label-width="100px">
        <el-form-item :label="$t('billingPage.zoneType')" prop="partitionType">
          <BjSelectLov v-model="form.partitionType" :option-list="ZONE_TYPE_LIST" :placeholder="$t('billingPage.zoneType')" />
        </el-form-item>
        <el-form-item :label="$t('BusinessLogisticsCompanyPostCode.country')" prop="country">
          <BjSelectLov v-model="form.country" :option-list="COUNTRY_NAME_AND_TWOCODE" :placeholder="$t('BusinessLogisticsCompanyPostCode.country')" />
        </el-form-item>
        <!-- 州：仅城市类型(2)显示，非必填 -->
        <el-form-item v-if="form.partitionType === '2'" :label="$t('billingPage.zoneState')" prop="state">
          <BjInput v-model="form.state" :placeholder="$t('billingPage.zoneState')" maxlength="100" :show-word-limit="true" />
        </el-form-item>
        <!-- 城市：仅城市类型(2)显示 -->
        <el-form-item v-if="form.partitionType === '2'" :label="$t('billingPage.zoneCity')" prop="city">
          <BjInput v-model="form.city" :placeholder="$t('billingPage.zoneCity')" maxlength="100" :show-word-limit="true" />
        </el-form-item>
        <!-- 分区：全显示 -->
        <el-form-item :label="$t('billingPage.zone')" prop="partitionValue">
          <BjInput :value="form.partitionValue" :placeholder="$t('billingPage.zone')" maxlength="50" :show-word-limit="true" @input="handleFormZoneInput" />
        </el-form-item>
        <!-- 起始/结束邮编：邮编类型(1)或城市类型(2)显示 -->
        <el-form-item v-if="isFormPostCodeRangeVisible" :label="$t('billingPage.PostcodeS')" prop="postCodeFrom">
          <BjInput ref="formPostCodeFrom" :value="form.postCodeFrom" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('billingPage.PostcodeS')" :show-word-limit="true" @input="handlePostCodeInput('form', 'postCodeFrom', $event, 'formPostCodeFrom')" />
        </el-form-item>
        <el-form-item v-if="isFormPostCodeRangeVisible" :label="$t('billingPage.PostcodeE')" prop="postCodeTo">
          <BjInput ref="formPostCodeTo" :value="form.postCodeTo" :maxlength="MAX_LENGTH.SHORT_NAME" :placeholder="$t('billingPage.PostcodeE')" :show-word-limit="true" @input="handlePostCodeInput('form', 'postCodeTo', $event, 'formPostCodeTo')" />
        </el-form-item>
        <el-form-item :label="$t('billingPage.DEPRemark')" prop="remark">
          <BjInput v-model="form.remark" type="textarea" maxlength="200" :placeholder="$t('billingPage.DEPRemark')" :rows="4" :show-word-limit="true" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onConfirm()">{{ $t('okText') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { logisticApi } from '@/api';
  import { COUNTRY_NAME_AND_TWOCODE } from '@/utils/statics';

  const patternStateName = /^(?=.*[A-Za-z\u4e00-\u9fa5])[A-Za-z\u4e00-\u9fa5\s]+$/;
  const patternZone = /^[A-Za-z0-9 ]+$/;
  const patternInvalidZoneValue = /[^A-Za-z0-9 ]/g;
  const patternPostCode = /^[A-Za-z0-9]+$/;

  function formatPostCode(value) {
    return value === null || value === undefined ? '' : String(value).trim().toUpperCase();
  }

  function isPostCodeRangeInvalid(postCodeFrom, postCodeTo) {
    const startPostCode = formatPostCode(postCodeFrom);
    const endPostCode = formatPostCode(postCodeTo);
    if (!startPostCode || !endPostCode || !patternPostCode.test(startPostCode) || !patternPostCode.test(endPostCode)) return false;
    return startPostCode.localeCompare(endPostCode, 'en', { numeric: true, sensitivity: 'base' }) > 0;
  }

  export default {
    name: 'BusinessLogisticsZoneDetail',
    mixins: [pageMiXin],
    data() {
      return {
        colSpan: 4,
        COUNTRY_NAME_AND_TWOCODE,
        ZONE_TYPE_LIST: [
          { label: this.$t('billingPage.zonePostCode'), value: '1' },
          { label: this.$t('billingPage.zoneCity'), value: '2' },
          { label: this.$t('billingPage.zoneCountry'), value: '3' },
        ],
        queryApi: logisticApi.getLogisticGroupDetail,
        queryParams: {
          logisticsGroupId: this.$route.query.id,

          partitionType: null,
          partitionValue: null,
          country: null,
          city: null,
          postCodeFrom: null,
          postCodeTo: null,
        },
        labelList: [
          { label: this.$t('billingPage.zoneType'), prop: 'partitionType', isCheck: true, disabled: false },
          { label: this.$t('billingPage.zone'), prop: 'partitionValue', isCheck: true, disabled: false },
          { label: this.$t('billingPage.zoneCountry'), prop: 'country', isCheck: true, disabled: false },
          { label: this.$t('billingPage.zoneState'), prop: 'state', isCheck: true, disabled: false },
          { label: this.$t('billingPage.zoneCity'), prop: 'city', isCheck: true, disabled: false },
          { label: this.$t('billingPage.PostcodeS'), prop: 'postCodeFrom', isCheck: true, disabled: false },
          { label: this.$t('billingPage.PostcodeE'), prop: 'postCodeTo', isCheck: true, disabled: false },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 187 },
        ],
        dialogVisible: false,
        form: {
          partitionType: null,
          country: null,
          state: null,
          city: null,
          partitionValue: null,
          postCodeFrom: null,
          postCodeTo: null,
          remark: null,
        },
      };
    },
    computed: {
      isFormPostCodeRangeVisible() {
        return this.form.partitionType === '1' || this.form.partitionType === '2';
      },
      rules() {
        const validatePostCodeRange = (rule, value, callback) => {
          if (isPostCodeRangeInvalid(this.form.postCodeFrom, this.form.postCodeTo)) {
            callback(new Error(this.$t('BusinessLogisticsCompanyPostCode.ps1')));
          } else {
            callback();
          }
        };
        const rules = {
          partitionType: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          country: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
          partitionValue: [
            { required: true, message: this.$t('inputText'), trigger: 'blur' },
            { pattern: patternZone, message: `${this.$t('billingPage.zone')} ${this.$t('formatErrorText')}`, trigger: 'blur' },
          ],
        };
        // 仅城市类型(2)时校验城市
        if (this.form.partitionType === '2') {
          rules.state = [
            { pattern: patternStateName, message: `${this.$t('billingPage.zoneState')} ${this.$t('formatErrorText')}`, trigger: 'blur' },
          ];
          rules.city = [
            { required: true, message: this.$t('inputText'), trigger: 'blur' },
          ];
          rules.postCodeFrom = [
            { pattern: patternPostCode, message: `${this.$t('billingPage.PostcodeS')} ${this.$t('formatErrorText')}`, trigger: 'blur' },
            { validator: validatePostCodeRange, trigger: 'blur' },
          ];
          rules.postCodeTo = [
            { pattern: patternPostCode, message: `${this.$t('billingPage.PostcodeE')} ${this.$t('formatErrorText')}`, trigger: 'blur' },
            { validator: validatePostCodeRange, trigger: 'blur' },
          ];
        }
        // 仅邮编类型(1)时校验起始/结束邮编
        if (this.form.partitionType === '1') {
          rules.postCodeFrom = [
            { required: true, message: this.$t('inputText'), trigger: 'blur' },
            { pattern: patternPostCode, message: `${this.$t('billingPage.PostcodeS')} ${this.$t('formatErrorText')}`, trigger: 'blur' },
            { validator: validatePostCodeRange, trigger: 'blur' },
          ];
          rules.postCodeTo = [
            { required: true, message: this.$t('inputText'), trigger: 'blur' },
            { pattern: patternPostCode, message: `${this.$t('billingPage.PostcodeE')} ${this.$t('formatErrorText')}`, trigger: 'blur' },
            { validator: validatePostCodeRange, trigger: 'blur' },
          ];
        }
        return rules;
      },
    },
    watch: {
      'form.partitionType'(val) {
        // 切换分区类型时清空隐藏字段的值
        if (val !== '2') {
          this.form.state = null;
          this.form.city = null;
        }
        if (val !== '1' && val !== '2') {
          this.form.postCodeFrom = null;
          this.form.postCodeTo = null;
        }
        // 清除旧的校验状态
        this.$nextTick(() => {
          this.$refs.form && this.$refs.form.clearValidate();
        });
      },
    },
    methods: {
      handleQueryZoneInput(value) {
        const zoneValue = value === null || value === undefined ? '' : String(value);
        if (!zoneValue) {
          this.queryParams.partitionValue = null;
          return;
        }
        const sanitizedValue = zoneValue.replace(patternInvalidZoneValue, '');
        this.queryParams.partitionValue = sanitizedValue.trim() ? sanitizedValue : null;
      },
      handleFormZoneInput(value) {
        const zoneValue = value === null || value === undefined ? '' : String(value);
        if (!zoneValue) {
          this.form.partitionValue = null;
          return;
        }
        const sanitizedValue = zoneValue.replace(patternInvalidZoneValue, '');
        this.form.partitionValue = sanitizedValue.trim() ? sanitizedValue : null;
      },
      handlePostCodeInput(targetName, fieldName, value, refName) {
        const postCode = value === null || value === undefined ? '' : String(value);
        if (!postCode) {
          this[targetName][fieldName] = null;
          return;
        }
        if (!patternPostCode.test(postCode)) {
          this[targetName][fieldName] = null;
          this.$nextTick(() => {
            const postCodeInput = this.$refs[refName];
            if (postCodeInput) {
              postCodeInput.id = null;
            }
          });
          return;
        }
        this[targetName][fieldName] = postCode;
      },
      beforeQuerySearch(conditionObj) {
        const queryCondition = {
          ...conditionObj,
          city: conditionObj.city ? String(conditionObj.city).trim() : conditionObj.city,
        };
        if (isPostCodeRangeInvalid(conditionObj.postCodeFrom, conditionObj.postCodeTo)) {
          this.$message.warning(this.$t('BusinessLogisticsCompanyPostCode.ps1'));
          const obj = {
            ...queryCondition,
            postCodeFrom: null,
            postCodeTo: null
          };
          return new Promise(resolve => {
            resolve(obj);
          });
        } else {
          return new Promise(resolve => {
            resolve(queryCondition);
          });
        }
      },
      onQueryPartitionTypeChange(val) {
        // 切换分区类型时清空已禁用字段的值
        if (val !== '2') {
          this.queryParams.city = null;
        }
        if (val !== '1' && val !== '2') {
          this.queryParams.postCodeFrom = null;
          this.queryParams.postCodeTo = null;
        }
        this.handleQuery();
      },
      onAdd() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs['form'] && this.$refs['form'].clearValidate();
        });
      },
      // 批量删除
      onBulkDel() {
        if (!this.selectedRows.length) {
          this.$message.warning(this.$t('chooseText'));
          return;
        }
        const ids = this.selectedRows.map(e => e.id);
        this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            logisticApi.delLogisticGroupDetail({ ids }).then(res => {
              if (!res.failed) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          })
          .catch(() => {});
      },
      onImport() {
        // 跳往导入页面
        this.$router.push({
          name: 'BusinessLogisticsZoneImportFile',
          query: { logisticsGroupId: this.$route.query.id },
        });
      },
      onEdit(row) {
        this.form = Object.assign({
          partitionType: null,
          country: null,
          state: null,
          city: null,
          partitionValue: null,
          postCodeFrom: null,
          postCodeTo: null,
          remark: null,
        }, JSON.parse(JSON.stringify(row)));
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs['form'] && this.$refs['form'].clearValidate();
        });
      },
      handleClose() {
        this.form = {
          partitionType: null,
          country: null,
          state: null,
          city: null,
          partitionValue: null,
          postCodeFrom: null,
          postCodeTo: null,
          remark: null
        };
        this.dialogVisible = false;
      },
      onConfirm() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            // 邮编类型(1)或城市类型(2)时校验邮编逻辑
            if (this.isFormPostCodeRangeVisible) {
              if (isPostCodeRangeInvalid(this.form.postCodeFrom, this.form.postCodeTo)) return this.$message.warning(this.$t('BusinessLogisticsCompanyPostCode.ps1'));
            }
            const payload = {
              ...this.form,
              logisticsGroupId: this.$route.query.id,
              city: this.form.city ? String(this.form.city).trim() : this.form.city,
              partitionValue: this.form.partitionValue ? String(this.form.partitionValue).trim() : this.form.partitionValue,
            };
            if (this.form.id) {
              // 编辑
              logisticApi.updateLogisticGroupDetail(payload).then(res => {
                if (!res.failed) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.handleClose();
                    this.reFresh();
                  }, 500);
                }
              });
            } else {
              // 新增
              logisticApi.addLogisticGroupDetail(payload).then(res => {
                if (!res.failed) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.handleClose();
                    this.reFresh();
                  }, 500);
                }
              });
            }
          }
        });
      },
      onDelete(row) {
        this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            logisticApi.delLogisticGroupDetail({ids: [row.id]}).then(res => {
              if (!res.failed) {
                this.$message.success(this.$t('toast.operationSuccessText'));
                setTimeout(() => {
                  this.reFresh();
                }, 500);
              }
            });
          })
          .catch(() => {});
      },

      beforeResetSearch() {
        this.queryParams.zoneGroup = null;
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
::v-deep .bj-page .el-form-item__label {
  display: none;
}
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
